import { DependencyList, EffectCallback, useEffect } from 'react';

export const useEffectCustom = (fn: EffectCallback, deps: DependencyList) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useEffect(fn, deps);
};
